module.exports = __webpack_public_path__ + "static/media/course-maximum-units.ba33b428.svg";